import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { Rectangle } from 'pixi.js';

export interface TimerEvent {
    destroy(): void;
    hasDispatched: boolean;
    timeoutId?: number;
    intervalId?: number;
}

export class Scene {
    public game: Game;
    public gameStore: GameStore;

    constructor(game: Game) {
        this.game = game;
        this.gameStore = this.game.gameStore;
        Logger.log(LoggerLevel.Constructor, {
            message: 'Scene constructor',
            source: LoggerSource.Game
        });

        this.init();
    }

    public get screen(): Rectangle {
        return this.game.renderer.screen;
    }

    public init(): void {
        this.gameStore = this.game.gameStore;
    }

    public time = {
        delayedCall(delay: number, callback: (...args: any[]) => any): TimerEvent {
            const timerEvent: TimerEvent = {
                hasDispatched: false,
                timeoutId: 0,
                destroy: () => {}
            };

            timerEvent.timeoutId = window.setTimeout(() => {
                callback();
                timerEvent.hasDispatched = true;
            }, delay);

            timerEvent.destroy = () => window.clearTimeout(timerEvent.timeoutId);
            return timerEvent;
        },

        addEvent(config: { delay: number; repeat?: number; executeFirstImmediately?: boolean; callback: () => void }): Partial<TimerEvent> {
            let count = 0;
            let intervalId: number;

            const callback = () => {
                config.callback();

                if (config.repeat !== undefined) {
                    count++;

                    if (count >= config.repeat) {
                        window.clearInterval(intervalId);
                    }
                }
            };

            if (config.executeFirstImmediately) {
                callback();
            }

            intervalId = window.setInterval(callback, config.delay);

            return {
                destroy: () => window.clearInterval(intervalId)
            };
        }
    };
}
